<template>
    <section class="section-others">
        <div class="inner">
            <div class="ttl" data-js="popupAnimation" data-popupAnimation-state="notMoved" data-popupAnimation-start="100" data-popupAnimation-delay="0">See other<br />luxury destinations</div>
            <div class="link" data-js="popupAnimation" data-popupAnimation-state="notMoved" data-popupAnimation-start="100" data-popupAnimation-delay="0"><router-link :to="{name: 'LuxuryTravel'}">See all</router-link></div>
            <div class="imgs" data-js="popupAnimation" data-popupAnimation-state="notMoved" data-popupAnimation-start="100" data-popupAnimation-delay="0">
                <ul>
                    <li><router-link :to="{name: 'LuxuryTravel01'}"><img src="../../assets/luxury_travel/see_other_luxury/see_other_luxury01.jpg" alt=""></router-link></li>
                    <li><router-link :to="{name: 'LuxuryTravel02'}"><img src="../../assets/luxury_travel/see_other_luxury/see_other_luxury02.jpg" alt=""></router-link></li>
                    <li><router-link :to="{name: 'LuxuryTravel03'}"><img src="../../assets/luxury_travel/see_other_luxury/see_other_luxury03.jpg" alt=""></router-link></li>
                    <li><router-link :to="{name: 'LuxuryTravel04'}"><img src="../../assets/luxury_travel/see_other_luxury/see_other_luxury04.jpg" alt=""></router-link></li>
                    <li><router-link :to="{name: 'LuxuryTravel05'}"><img src="../../assets/luxury_travel/see_other_luxury/see_other_luxury05.jpg" alt=""></router-link></li>
                    <li><router-link :to="{name: 'LuxuryTravel06'}"><img src="../../assets/luxury_travel/see_other_luxury/see_other_luxury06.jpg" alt=""></router-link></li>
                    <li></li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "SeeOtherLuxury",
    data: function () {
        return {
            windowHeight: window.innerHeight,
        }
    },
    mounted: function () {

        // 初回 popupAnimation 呼び出し
        this.runPopupAnimation();

        // スクロールイベント付与
        let scrollTimerId = null;
        window.addEventListener('scroll', ()=>{
            clearTimeout(scrollTimerId);
            scrollTimerId = setTimeout(()=>{
                this.handleScroll();
            }, 50);
        });
    },
    beforeDestroy: function () {
        // スクロールイベント削除
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll: function () {
            this.runPopupAnimation();
        },
        runPopupAnimation: function(){
            const elements = document.querySelectorAll('[data-js="popupAnimation"]');
            elements.forEach(element => {
                this.popupAnimation(element);
            });
        },
        popupAnimation: function (element) {
            const state = element.getAttribute('data-popupAnimation-state');
            const delay = element.getAttribute('data-popupAnimation-delay');
            const start = element.getAttribute('data-popupAnimation-start');
            if (state === 'notMoved') {
                const topHeight = element.getBoundingClientRect().top;

                if (topHeight < this.windowHeight - start) {
                    setTimeout(() => {
                        element.setAttribute('data-popupAnimation-state', 'moved');
                    }, delay);
                }
            } else {
                if (element.getBoundingClientRect().top > this.windowHeight) {
                    element.setAttribute('data-popupAnimation-state', 'notMoved');
                }
            }
        }
    },
}
</script>

<style src="./SeeOtherLuxury.scss" lang="scss" scoped/>
